export var getSiblingRange = function getSiblingRange(isShowingPageNumbers) {
  return isShowingPageNumbers ? 0 : undefined;
};